// src/components/krums/TiendaPaquetes.js
import React, { useState, useEffect } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { listarPaquetes, crearIntencionPago } from '../../services/api';
import CheckoutForm from '../pagos/CheckoutForm';
import MercadoPagoCheckout from '../pagos/MercadoPagoCheckout';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const TiendaPaquetes = () => {
  const [paquetes, setPaquetes] = useState({ unicos: [], suscripciones: [] });
  const [planSeleccionado, setPlanSeleccionado] = useState(null);
  const [clientSecret, setClientSecret] = useState('');
  const [loading, setLoading] = useState(true);
  const [mostrarCheckout, setMostrarCheckout] = useState(false);
  const [metodoPago, setMetodoPago] = useState('stripe');

  useEffect(() => {
    cargarPaquetes();
  }, []);

  const cargarPaquetes = async () => {
    try {
      const response = await listarPaquetes();
      const todos = response.data.planes || [];
      
      // Separar por tipo
      setPaquetes({
        unicos: todos.filter(p => p.tipo === 'unico'),
        suscripciones: todos.filter(p => p.tipo === 'suscripcion')
      });
    } catch (error) {
      console.error('Error cargando paquetes:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleComprar = async (plan) => {
    console.log('Iniciando compra del plan:', plan);
    setPlanSeleccionado(plan);
    setMostrarCheckout(true);
    
    try {
      const response = await crearIntencionPago(plan.id);
      console.log('Respuesta:', response.data);
      setClientSecret(response.data.clientSecret);
    } catch (error) {
      console.error('Error:', error);
      setMostrarCheckout(false);
    }
  };

  const handlePagoExitoso = () => {
    setMostrarCheckout(false);
    setPlanSeleccionado(null);
    cargarPaquetes();
  };

  if (loading) return <div className="loading">Cargando planes...</div>;

  return (
    <div className="tienda-paquetes">
      <h2>🌟 Adquiere más Krums</h2>

      {/* SECCIÓN: SUSCRIPCIONES MENSUALES */}
      {paquetes.suscripciones.length > 0 && (
        <div className="seccion-planes">
          <h3 className="seccion-titulo">
            <span className="seccion-icono">🔄</span>
            Planes de Suscripción Mensual
          </h3>
          <p className="seccion-descripcion">
            Ideal para creadores frecuentes. Se renueva cada mes automáticamente.
          </p>
          <div className="paquetes-grid">
            {paquetes.suscripciones.map(p => (
              <div key={p.id} className="paquete-card suscripcion">
                <div className="paquete-badge">🔄 Mensual</div>
                <h3>{p.nombre}</h3>
                <p className="precio">${p.precio_mxn} MXN <span className="periodo">/mes</span></p>
                <p className="krums">{p.krums} Krums <span className="cada-mes">cada mes</span></p>
                <p className="imagenes">{p.imagenes} imágenes incluidas</p>
                <p className="descripcion">{p.descripcion}</p>
                <button 
                  onClick={() => handleComprar(p)}
                  className="btn-comprar suscripcion"
                >
                  Suscribirse
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* SECCIÓN: PAQUETES DE PAGO ÚNICO */}
      {paquetes.unicos.length > 0 && (
        <div className="seccion-planes">
          <h3 className="seccion-titulo">
            <span className="seccion-icono">📦</span>
            Paquetes de Pago Único
          </h3>
          <p className="seccion-descripcion">
            Los Krums no caducan. Ideal para uso ocasional.
          </p>
          <div className="paquetes-grid">
            {paquetes.unicos.map(p => (
              <div key={p.id} className="paquete-card unico">
                <h3>{p.nombre}</h3>
                <p className="precio">${p.precio_mxn} MXN</p>
                <p className="krums">{p.krums} Krums</p>
                <p className="imagenes">{p.imagenes} imágenes</p>
                <p className="descripcion">{p.descripcion}</p>
                <button 
                  onClick={() => handleComprar(p)}
                  className="btn-comprar"
                >
                  Comprar
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* MODAL DE CHECKOUT */}
      {mostrarCheckout && clientSecret && planSeleccionado && (
        <div className="checkout-modal">
          <div className="checkout-content">
            <h3>Completar pago</h3>
            <p>Plan: {planSeleccionado.nombre}</p>
            <p>Total: ${planSeleccionado.precio_mxn} MXN</p>
            
            {planSeleccionado.tipo === 'suscripcion' && (
              <div className="aviso-suscripcion">
                ⚡ Esta es una suscripción mensual. Se renovará automáticamente cada mes.
              </div>
            )}
            
            <div className="metodos-pago-tabs">
              <button 
                className={metodoPago === 'stripe' ? 'active' : ''}
                onClick={() => setMetodoPago('stripe')}
              >
                💳 Tarjeta (Stripe)
              </button>
              <button 
                className={metodoPago === 'mercadopago' ? 'active' : ''}
                onClick={() => setMetodoPago('mercadopago')}
              >
                💵 Mercado Pago
              </button>
            </div>

            {metodoPago === 'stripe' ? (
              <Elements stripe={stripePromise} options={{ clientSecret }}>
                <CheckoutForm 
                  monto={planSeleccionado.precio_mxn}
                  onSuccess={handlePagoExitoso}
                  onError={() => setMostrarCheckout(false)}
                />
              </Elements>
            ) : (
              <MercadoPagoCheckout 
                plan={planSeleccionado}
                onSuccess={handlePagoExitoso}
                onError={() => setMostrarCheckout(false)}
              />
            )}
            
            <button 
              className="btn-cancelar"
              onClick={() => setMostrarCheckout(false)}
            >
              Cancelar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TiendaPaquetes;